import LTR from "@brand-icons/ploom/ui-plus/ui-plus-ltr.svg";

import { iconFactory } from "../iconFactory";

export const UiPlusIcon = iconFactory("UiPlusIcon", LTR);
